export default "__VITE_ASSET__4pYAQy0l__"